<div id="outer" class="well container">
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="well-title">
        <div class="col-md-12">{{ !loading ? (isEditMode ? "Edit" : "Create") : "" }} Location</div>
    </div>
    <div class="col-md-12">
        <a class="back-link" routerLink="/configure/ptplocation">Back to PTP Shipping Locations</a>
    </div>
    <div class="col-md-12 well-content">
        <div class="panel panel-default">
            <div class="panel-body">
                <form nz-form [formGroup]="form" class="form-horizontal">
                    <div class="form-group">
                        <label for="shippingLocation" class="col-md-2 control-label">
                            Name<span style="color: red"> *</span>
                        </label>
                        <div class="col-md-6">
                            <input
                                id="shippingLocation"
                                type="text"
                                maxlength="200"
                                class="form-control"
                                formControlName="shippingLocation" />
                            @if (form.get("shippingLocation")?.touched && form.get("shippingLocation")?.invalid) {
                                <span class="text-danger"> Name is required </span>
                            }
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="shipToAddressLine1" class="col-md-2 control-label">Address Line 1</label>
                        <div class="col-md-6">
                            <input
                                id="shipToAddressLine1"
                                type="text"
                                class="form-control"
                                formControlName="shipToAddressLine1" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="shipToAddressLine2" class="col-md-2 control-label">Address Line 2</label>
                        <div class="col-md-6">
                            <input
                                id="shipToAddressLine2"
                                type="text"
                                class="form-control"
                                formControlName="shipToAddressLine2" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="shipToCity" class="col-md-2 control-label">City</label>
                        <div class="col-md-6">
                            <input id="shipToCity" type="text" class="form-control" formControlName="shipToCity" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="shipToState" class="col-md-2 control-label">State</label>
                        <div class="col-md-6">
                            <input id="shipToState" type="text" class="form-control" formControlName="shipToState" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="shipToZip" class="col-md-2 control-label">Postal Code</label>
                        <div class="col-md-6">
                            <input id="shipToZip" type="text" class="form-control" formControlName="shipToZip" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="shipToCountry" class="col-md-2 control-label">Country</label>
                        <div class="col-md-6">
                            <input
                                id="shipToCountry"
                                type="text"
                                class="form-control"
                                formControlName="shipToCountry" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="shipToPhone" class="col-md-2 control-label">Phone</label>
                        <div class="col-md-6">
                            <input id="shipToPhone" type="text" class="form-control" formControlName="shipToPhone" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="shipToEmail" class="col-md-2 control-label">Email</label>
                        <div class="col-md-6">
                            <input id="shipToEmail" type="text" class="form-control" formControlName="shipToEmail" />
                            @if (form.get("shipToEmail")?.touched && form.get("shipToEmail")?.invalid) {
                                <span class="text-danger"> Enter a valid email </span>
                            }
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="shipToFax" class="col-md-2 control-label">Fax</label>
                        <div class="col-md-6">
                            <input id="shipToFax" type="text" class="form-control" formControlName="shipToFax" />
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <button nz-button nzType="primary" (click)="save()">Save Changes</button>
    </div>
</div>
